import { healthTips } from './healthTips';

// Shared tip images for landing page + customer dashboard
export const tipImages = {
  'Stay Hydrated':
    'https://images.unsplash.com/photo-1548839140-29a749e1cf4d?auto=format&fit=crop&w=800&q=80',
  'Regular Exercise':
    'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=800&q=80',
  'Balanced Diet':
    'https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=800&q=80',
  'Adequate Sleep':
    '/tip-adequate-sleep.png',
  'Wash Hands Regularly':
    '/tip-wash-hands.jpg',
  'Take Prescribed Medications Correctly':
    'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&w=800&q=80',
  'Manage Stress':
    'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=800&q=80',
  'Regular Health Check-ups':
    'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=800&q=80',
  'Protect Yourself from Sun':
    'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=800&q=80',
  'Practice Good Oral Hygiene':
    'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=800&q=80',
  'Include Fruits and Vegetables':
    '/tip-fruits-vegetables.png',
  'Prioritize Mental Health':
    'https://images.unsplash.com/photo-1493836512294-502baa1986e2?auto=format&fit=crop&w=800&q=80',
  'Read Medication Labels':
    '/tip-read-medication-labels.png',
  'Maintain a Health Journal':
    '/tip-health-journal.png',
  'Limit Alcohol Consumption':
    'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=800&q=80',
  'Quit Smoking':
    'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=800&q=80',
  'Maintain Good Posture':
    'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=800&q=80',
  'Stay Socially Connected':
    'https://images.unsplash.com/photo-1493836512294-502baa1986e2?auto=format&fit=crop&w=800&q=80',
  'Limit Screen Time':
    'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?auto=format&fit=crop&w=800&q=80',
  'Eat Breakfast':
    'https://images.unsplash.com/photo-1490645935967-10de6ba17061?auto=format&fit=crop&w=800&q=80',
  'Practice Portion Control':
    '/tip-fruits-vegetables.png',
  'Stay Active Throughout the Day':
    'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?auto=format&fit=crop&w=800&q=80',
  'Store Medications Properly':
    'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&w=800&q=80',
  'Never Share Prescriptions':
    '/tip-read-medication-labels.png'
};

const fallbackImages = [
  '/tip-fruits-vegetables.png',
  '/tip-wash-hands.jpg',
  '/tip-adequate-sleep.png',
  '/tip-health-journal.png',
  '/tip-read-medication-labels.png',
  'https://images.unsplash.com/photo-1548839140-29a749e1cf4d?auto=format&fit=crop&w=800&q=80'
];

export const getHealthTipImage = (title) => {
  if (tipImages[title]) return tipImages[title];
  let hash = 0;
  const key = String(title || '');
  for (let i = 0; i < key.length; i += 1) {
    hash = (hash + key.charCodeAt(i) * (i + 1)) % fallbackImages.length;
  }
  return fallbackImages[hash];
};

const selectedTitles = Object.keys(tipImages).filter((title) =>
  healthTips.some((tip) => tip.title === title)
);

export const landingHealthTips = selectedTitles
  .map((title) => {
    const tip = healthTips.find((item) => item.title === title);
    if (!tip) return null;
    return {
      ...tip,
      image: tipImages[title]
    };
  })
  .filter(Boolean);

export default landingHealthTips;
